import z from "zod";
import type { InnstillingerDto } from "@/api/generated";
import { formatKontonummer } from "@/utils";
export const translationPrefixForm = "pages.innstillinger.form";

export const cleanKontonummer = (kontonummer: string) => {
  return kontonummer.replace(/[ .]/g, "");
};

const kontonummerSchema = z
  .string()
  .regex(
    /^\d{4}[ .]?\d{2}[ .]?\d{5}$/,
    `${translationPrefixForm}.feil.kontonummer.ugyldig`,
  );
export const innstillingerFormSchema = z
  .object({
    fakturaEpost: z.email({
      message: `${translationPrefixForm}.feil.epost.ugyldig`,
    }),
    norgesprisKontonummer: kontonummerSchema,
    strømstønadKontonummer: kontonummerSchema,
  })
  .refine(
    (data) =>
      cleanKontonummer(data.norgesprisKontonummer) !==
      cleanKontonummer(data.strømstønadKontonummer),
    {
      message: `${translationPrefixForm}.feil.kontonummer.samme`,
      path: ["strømstønadKontonummer"],
    },
  );

export type innstillingerFormValues = z.infer<typeof innstillingerFormSchema>;

export function getDefaultInnstillingerFormValues(): innstillingerFormValues {
  return {
    fakturaEpost: "",
    strømstønadKontonummer: "",
    norgesprisKontonummer: "",
  };
}

export function initFormValues(
  innstillinger: InnstillingerDto | null | undefined,
): innstillingerFormValues {
  return {
    fakturaEpost: innstillinger?.fakturaEpost ?? "",
    norgesprisKontonummer:
      formatKontonummer(innstillinger?.norgesprisKontonummer) ?? "",
    strømstønadKontonummer:
      formatKontonummer(innstillinger?.strømstønadKontonummer) ?? "",
  };
}
